export const ROUTES = {
  start: '/catalog/start',
  doorLine: '/catalog/doorLine',
  doorDesign: '/catalog/:productGroup/doorDesign',
  material: '/catalog/:doorLineId/material',
  materialDoorDesign: '/catalog/:doorLineId/material/:materialId/doorDesign',
  millingGroup: '/catalog/:doorLineId/millingGroup',
  millingGroupDoorDesign: '/catalog/:doorLineId/millingGroup/:millingGroupId/doorDesign',
  glassDoorLine: '/catalog/glass/doorLine',
  glassDoorDesign: '/catalog/glass/:doorLineId/doorDesign',
  cart: '/core/cart',
  projectCart: '/core/cart/:projectCode',
  creator: '/core/new/:productId',
  editor: '/core/edit/:doorId',
  sharedDoor: '/core/sharedDoor/',
  sharedProject: '/core/sharedProject/',
  creatorByEan: '/core/ean/:productId/:ean',
  notFound: '/404'
};

export function doorDesignLink(id: string): string {
  return ROUTES.doorDesign.replace(/:productGroup/, id);
}

export function creatorLink(id: string): string {
  return ROUTES.creator.replace(/:productId/, id);
}

export function creatorByEanLink(id: string, ean: string): string {
  return ROUTES.creatorByEan.replace(/:productId/, id).replace(/:ean/, ean);
}

export function editorLink(id: string): string {
  return ROUTES.editor.replace(/:doorId/, id);
}

export function projectCartLink(code: string): string {
  return ROUTES.projectCart.replace(/:projectCode/, code);
}

export function notFoundLink(): string {
  return '/404';
}

export function doorLineLink(): string {
  return '/catalog/doorLine';
}

export function materialLink(doorLineId: string): string {
  return ROUTES.material.replace(/:doorLineId/, doorLineId);
}

export function materialDoorDesignLink(doorLineId: string, materialId: string): string {
  return ROUTES.materialDoorDesign.replace(/:doorLineId/, doorLineId).replace(/:materialId/, materialId);
}

export function millingGroupLink(doorLineId: string): string {
  return ROUTES.millingGroup.replace(/:doorLineId/, doorLineId);
}

export function millingGroupDoorDesignLink(doorLineId: string, millingGroupId: string): string {
  return ROUTES.millingGroupDoorDesign.replace(/:doorLineId/, doorLineId).replace(/:millingGroupId/, millingGroupId);
}

export function glassDoorLineLink(): string {
  return ROUTES.glassDoorLine;
}

export function glassDoorDesignLink(doorLineId: string): string {
  return ROUTES.glassDoorDesign.replace(/:doorLineId/, doorLineId);
}
